const ISO_8601 = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/;

export const dateFromIso8601 = (
  value: string
): Date | undefined => {

  if (!!value && ISO_8601.test(value)) {
    return new Date(value);
  } else {
    return undefined;
  }
};

export const tryParseDateFromIso8601 = (
  value: string
): Date | string => {
  return dateFromIso8601(value) || value;
};
